
import VueRouter from "vue-router";

import PostList from "../components/PostListComponent.vue";
import PostDetail from "../components/PostDetailComponent.vue";
import PostCategory from "../components/PostCategoryComponent.vue";

import Contact from "../components/ContactComponent.vue";
import Puja from "../components/PujaComponent.vue";
import PujaList from "../components/PujaListComponent.vue";
import CompraList from "../components/CompraListComponent.vue";

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import VueHasErrorLaravel from 'vue-has-error-laravel'

//import { vue } from "laravel-mix";
import Vue from "vue";

import swal from 'sweetalert';
import Swal from 'vue-sweetalert2';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

window.Vue = require('vue');
Vue.use(VueRouter);
Vue.use(VueFormWizard);
Vue.component('v-select', vSelect)
Vue.use(VueHasErrorLaravel)
Vue.use(VueSweetalert2);


export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: "/list", component: PostList, name: "list" },
        { path: "/inicio/list/", component: PostList, name: "lista" },
        { path: "/:id", component: PostList, name: "list_filter" },
        { path: "/login", name: "login" },
        {
          path: "/inicio/list/detalle/:slug",
          component: PostDetail,
          name: "detalle",
          beforeRouteUpdate(to, from, next) {
            if (to.params.slug !== from.params.slug) {
              this.$router.push({ name: 'detalle', params: { slug: to.params.slug } });
            } else {
              next();
            }
          }
        },
        
        { path: "/list/detail/:slug", component: PostDetail, name: "detail", beforeRouteUpdate(to, from, next) {
            if (to.params.slug !== from.params.slug) {
              this.$router.push({ name: 'detail', params: { slug: to.params.slug } });
            } else {
              next();
            }
          } },
        { path: "/categoria/:category_path", component: PostCategory, name: "categoria" },
        { path: "/contact", component: Contact, name: "contact" },
        { path: "/puja/:id", component: Puja, name: "puja" },
        { path: "/pujas", component: PujaList, name: "list_puja" },
        { path: "/compras", component: CompraList, name: "list_compra" },
    ] // short for `routes: routes`
});